module.exports = __webpack_public_path__ + "static/media/favicon.7f25a91e.png";